<div class="fuild-container login">
  <div class="row">
    <div class="col-md-8 banner" banner></div>
    <div class="col-md-4 form login-sidebar">
      <div class="p-5 form-container">
        <div class="brand-logo text-center">
          <img [src]="logo">
        </div>
        <br/>
        <div class="text-center d-none">
          <h1 class="h4 text-gray-900 mb-4">Welcome Back!</h1>
        </div>
        <alert></alert>
        <form class="login" name="form" (ngSubmit)="f.form.valid && login()" #f="ngForm" novalidate>
          <div class="form-group" [ngClass]="{ 'has-error': f.submitted && !username.valid }">
            <input type="text" name="username"class="form-control form-control-sm"  [(ngModel)]="model.username" #username="ngModel" required  placeholder="Enter username...">
            @if (f.submitted && !username.valid) {
              <div class="help-block">Username is required</div>
            }
          </div>
          <div class="form-group password-field" [ngClass]="{ 'has-error': f.submitted && !password.valid }">
            <input [type]="fieldType" class="form-control form-control-sm form-control-user"  name="password" [(ngModel)]="model.password" #password="ngModel" required  placeholder="Enter password">
            <span class="viewpassword" (mousedown)="mouseDown()" (mouseup)="mouseUp()"><i class="fa fa-eye"></i></span>
            @if (f.submitted && !password.valid) {
              <div class="help-block">Password is required</div>
            }
          </div>
          <div class="form-group d-none">
            <div class="custom-control custom-checkbox small">
              <input type="checkbox" class="custom-control-input" id="customCheck">
              <label class="custom-control-label" for="customCheck">Remember Me</label>
            </div>
          </div>
          <button type="submit"class="btn btn-sm btn-primary btn-icon-split btn-block" [disabled]="loading">
            <span class="icon text-white-50">
              <i class="fas fa-arrow-right"></i>
            </span>
            <span class="text">Sign to your account</span>
          </button>
        </form>
        <hr>
          <div class="text-center float-left">
            <a class="small" [routerLink]="['/forgot-password']">Forgot Password?</a>
          </div>
          <div class="text-center float-right">
            <!--<a class="small" href="register.html">Create an Account!</a>-->
          </div>
          <br/><br/>
          <br/><br/>
          <div class="text-center">
            <a href="https://www.sullivanstrickler.com/contact-us/" target="_blank" class="btn btn-sm btn-primary btn-demo btn-block">
              Request a Free Demo
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>